import BidTooLow from '@/components/Errors/BidTooLow.vue'
import AuctionClosed from '@/components/Errors/AuctionClosed.vue'
import NotHighBidderVue from '@/components/Errors/NotHighBidder.vue'
import UnexpectedError from '@/components/Errors/UnexpectedError.vue'

export const codes = {
	NOT_HIGH_BIDDER: 9001,
}

export default {
	HttpError(reason: string, response: any) {
		let err = new Error(reason)
		err.response = response

		return err
	},
}

// wallets report user rejection inconsistently: EIP-1193 code 4001, ethers'
// ACTION_REJECTED, nested inside a -32603 internal error, or only in the message
export function wasDeclined(err: any): boolean {
	if (err?.code === 4001 || err?.code === 'ACTION_REJECTED') {
		return true
	}

	if (err?.data?.originalError?.code === 4001) {
		return true
	}

	return /user (denied|rejected)/i.test(String(err?.message ?? ''))
}

export function wasNotDeclined(err: Error) {
	return !wasDeclined(err)
}

export function isCustomError(err: Error) {
	return err.message.includes(`"code": -32603`) || Object.values(codes).indexOf(err.code) !== -1
}

export function buildErrorComponent(err: Error) {
	if (err.message.includes('BidTooLow')) {
		return BidTooLow
	}

	if (err.message.includes('AuctionClosed')) {
		return AuctionClosed
	}

	switch (err.code) {
		case codes.NOT_HIGH_BIDDER:
			return NotHighBidderVue
	}

	return UnexpectedError
}

export function make(code: number, message: string | undefined): Error {
	const err = new Error(message)
	err.code = code

	return err
}
